import type { Components, Theme } from "@mui/material";

export const covestroMuiTooltip: Components<Theme>["MuiTooltip"] = {
  styleOverrides: {
    tooltip: ({ theme }) => ({
      boxShadow: theme.shadows[8],
      color: theme.palette.getContrastText(theme.palette.grey["700"]),
      background: theme.palette.grey["700"],
      fontWeight: 400,
      fontSize: 13,
    }),
    arrow: ({ theme }) => ({
      color: theme.palette.grey["700"],
    }),
  },
};
